import { Chip, Avatar } from '@mui/material';

import { GroupOrServiceAvatar } from '@/components/Avatar/GroupOrServiceAvatar';

import type { FilterGroup } from './MultiGroupFilter';

interface MultiGroupFilterGroupTagsProps {
  value: FilterGroup[];
  getTagProps: (params: { index: number }) => Record<string, unknown>;
  tagLimit?: number | undefined;
  showMore: boolean;
  setShowMore: (showMore: boolean) => void;
  classes: {
    chipInputs: string;
  };
}

const DEFAULT_TAG_LIMIT = 5;

export const MultiGroupFilterGroupTags = ({
  value,
  getTagProps,
  tagLimit = DEFAULT_TAG_LIMIT,
  showMore,
  setShowMore,
  classes,
}: MultiGroupFilterGroupTagsProps) => {
  return (
    <div className={classes.chipInputs}>
      {value
        .map((option, index) => (
          <Chip
            avatar={
              <Avatar>
                <GroupOrServiceAvatar
                  size={16}
                  iconUrl={option.iconUrl}
                  groupOrServiceName={option.name}
                />
              </Avatar>
            }
            color="primary"
            size="small"
            label={option.name}
            {...getTagProps({ index })}
            key={option._id ?? ''}
          />
        ))
        .slice(0, showMore ? value.length : (tagLimit ?? value.length))}
      {!showMore && tagLimit && value.length > tagLimit ? (
        <Chip
          color="default"
          size="small"
          onClick={() => setShowMore(true)}
          label={`Show ${value.length - tagLimit} more`}
        />
      ) : (
        tagLimit &&
        value.length > tagLimit && (
          <Chip
            color="default"
            size="small"
            onClick={() => setShowMore(false)}
            label={`Show less`}
          />
        )
      )}
    </div>
  );
};
